<span
  class="sz-ic-circle"
  [class.sz-ic-circle--sm]="size() === 'sm'"
  [class.sz-ic-circle--md]="size() === 'md'"
  [class.sz-ic-circle--lg]="size() === 'lg'"
  [class.sz-ic-circle--lime]="accent() === 'lime'"
  [class.sz-ic-circle--ghost]="accent() === 'ghost'"
  [class.sz-ic-circle--ink]="accent() === 'ink'">
  <ng-content />
</span>
